import React from "react";
import { useAuth } from "../../context/AuthContext";

const AccessMenu = ({ open, onClose, onSelect, onNavigate }) => {
  const { isAuthenticated, logout } = useAuth();

  if (!open) return null;

  const handleClick = (section) => {
    if (onSelect) {
      // Convertir las secciones antiguas a rutas
      if (section === "user-demo") {
        onSelect("/login");
        // Scroll to top para login
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
      } else if (section === "contacto") {
        onSelect("/"); // Ir a la página principal donde está el contacto
        // No hacer scroll automático para contacto ya que debe ir a la sección
      } else if (section === "mi-area") {
        onSelect("/mi-area");
        // Scroll to top para mi-area
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 100);
      } else {
        onSelect(`/${section}`);
        // Scroll to top para todas las demás páginas, excepto baterías y servicios
        if (section !== "baterías" && section !== "servicios") {
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }, 100);
        }
      }
    }
    onClose();
  };

  const handleLogout = async () => {
    try {
      await logout();
      onClose();
      
      // Pequeña pausa para asegurar que el estado se actualice
      setTimeout(() => {
        if (onNavigate) onNavigate("/login");
      }, 100);
      
    } catch (error) {
      console.error('❌ Error durante logout:', error);
      onClose();
    }
  };

  return (
    <>
      {/* Fondo oscuro */}
      <div
        onClick={onClose}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.6)",
          animation: "fadeIn 0.3s ease",
          zIndex: 9998
        }}
      />

      {/* Panel lateral */}
      <div
        style={{
          position: "fixed",
          top: 0,
          right: 0,
          width: "300px",
          height: "100%",
          backgroundColor: "#fff",
          boxShadow: "-2px 0 6px rgba(0,0,0,0.3)",
          padding: "20px",
          animation: "slideInRight 0.3s ease",
          zIndex: 9999
        }}
      >
        <span
          onClick={onClose}
          style={{
            position: "absolute",
            top: "10px",
            right: "20px",
            fontSize: "28px",
            cursor: "pointer",
            color: "#28a745"
          }}
        >
          &times;
        </span>

        <h3 style={{ color: "#040504ff", marginTop: "40px" }}>Menú</h3>
        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {!isAuthenticated ? (
            <>
              <li
                onClick={() => handleClick("login")}
                style={menuItemStyle}
              >
                Iniciar sesión
              </li>
              <li
                onClick={() => handleClick("register")}
                style={menuItemStyle}
              >
                Registrarse
              </li>
            </>
          ) : (
            <>
              <li
                onClick={handleLogout}
                style={menuItemStyle}
              >
                Cerrar sesión
              </li>
            </>
          )}
          <li
            onClick={() => handleClick("contacto")}
            style={menuItemStyle}
          >
            Contacto
          </li>
        </ul>
      </div>

      {/* Animaciones */}
      <style>
        {`
          @keyframes slideInRight {
            from { transform: translateX(100%); }
            to { transform: translateX(0); }
          }
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
        `}
      </style>
    </>
  );
};

const menuItemStyle = {
  padding: "12px 0",
  borderBottom: "1px solid #1eb830ff",
  cursor: "pointer",
  color: "#28a745",
  fontWeight: "bold"
};

export default AccessMenu;
